import { doDataVaultRequest, doRequest } from '@/utils/request';

import * as urls from '../apiUrl';

const getNearestLocationData = async (
  brand: string,
  locale: any,
  lat: any,
  lng: any,
  originalat?: any,
  originalng?: any,
  distance?: any
) => {
  const response = await doDataVaultRequest(
    `${urls.getNearestStoreLocator(
      brand,
      locale,
      lat,
      lng,
      originalat,
      originalng,
      distance
    )}`,
    'get'
  );

  function removeEmptyUnitLocations(location: any, index: any, arr: any) {
    if (!location?.priceInfo || location?.priceInfo?.length === 0) {
      arr.splice(index, 1);
      return true;
    }
    return false;
  }
  await response?.data.filter(removeEmptyUnitLocations);
  return response;
};

const getLandingPageData = async (location: any, locale: any) => {
  return doDataVaultRequest(`${urls.getLandingPage(location, locale)}`, 'get');
};

const getFacilityPageData = async (
  location: any,
  brand: string,
  locale: any,
  facilityLen: any
) => {
  return doRequest(
    `${urls.getFacilitiesInfo(location, brand, locale, facilityLen)}`,
    'get'
  );
};

const getFacilityPageDataOffice = async (
  facilityId: any,
  brand: string,
  locale: any
) => {
  return doRequest(
    `${urls.getFacilitiesInfoOffice(facilityId, brand, locale)}`,
    'get'
  );
};

const getVehiclePageDataSEO = async (
  location: any,
  brand: string,
  locale: any
) => {
  return doRequest(`${urls.getVehicleSEOInfo(location, brand, locale)}`, 'get');
};

const getAllUnitsData = async (lcode: any, locale: any) => {
  return doDataVaultRequest(`${urls.getUnitsData(lcode, locale)}`, 'get');
};

export {
  getAllUnitsData,
  getFacilityPageData,
  getFacilityPageDataOffice,
  getLandingPageData,
  getNearestLocationData,
  getVehiclePageDataSEO,
};
